module.exports = __webpack_public_path__ + "media/img/frontend_application/banner-onboard-267e41eed3b656d997c03b88e06a1a54.png";